import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";

import type { SpecialIndicatorData } from "modules/Appointments/hooks";

export const useSpecialIndicatorsToFilter = () => useTypedQuery({ queryKey: AppointmentsQueryKeys.specialIndicatorsToFilter, initialData: {} }).data;

export const setSpecialIndicatorsToFilter = (specialIndicators: SpecialIndicatorData) =>
  typedQueryClient.setQueryData(AppointmentsQueryKeys.specialIndicatorsToFilter, specialIndicators);
